var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.tags.filter((t) => t.Text.length > 0)),function(t){return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(t.ToolTip),expression:"t.ToolTip"}],key:t.Text,staticClass:"package-tag",class:{
			'c-package-tag--green': t.Type == 'UnderPriceCap' || t.Type == 'DiscountTag',
			'c-package-tag--orange':
				t.Text == 'Vast tarief' || t.Text == 'Vast actietarief' || t.Type == 'MandatorySmartMeter',
		}},[_vm._v(" "+_vm._s(t.Text)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }